var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 62,
      height: 62
    },
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.82,
    cy: 30.6067,
    r: 30.6067,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0111 41.7692H23.6287C21.6413 41.7692 20.0176 40.1456 20.0176 38.1581V23.7757C20.0176 21.7882 21.6413 20.1646 23.6287 20.1646H38.0111C39.9986 20.1646 41.6223 21.7882 41.6223 23.7757V38.1581C41.6223 40.1544 40.0075 41.7692 38.0111 41.7692Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8244 36.517C29.3427 36.517 27.9497 35.9403 26.9027 34.8933C25.8558 33.8463 25.2791 32.4533 25.2791 30.9716C25.2791 29.4899 25.8558 28.0969 26.9027 27.0499C27.9497 26.003 29.3427 25.4263 30.8244 25.4263C32.3061 25.4263 33.6991 26.003 34.7461 27.0499C35.793 28.0969 36.3698 29.4899 36.3698 30.9716C36.3698 32.4533 35.793 33.8463 34.7461 34.8933C33.6902 35.9403 32.3061 36.517 30.8244 36.517ZM30.8244 26.6063C28.4199 26.6063 26.4591 28.5583 26.4591 30.9716C26.4591 33.3761 28.4111 35.3369 30.8244 35.3369C33.2289 35.3369 35.1897 33.385 35.1897 30.9716C35.1808 28.5672 33.2289 26.6063 30.8244 26.6063Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4507 25.2437C38.0388 25.2437 38.5155 24.767 38.5155 24.179C38.5155 23.591 38.0388 23.1143 37.4507 23.1143C36.8627 23.1143 36.386 23.591 36.386 24.179C36.386 24.767 36.8627 25.2437 37.4507 25.2437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.04922280d62458d0931dea0dbe1836c3.svg";
export { ForwardRef as ReactComponent };